"use strict";

var _objectWithoutProperties = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _AvatarImage = require("./AvatarImage.style");

var AvatarImage = function AvatarImage(_ref) {
  var image = _ref.image,
      name = _ref.name,
      rectangular = _ref.rectangular,
      size = _ref.size,
      rest = _objectWithoutProperties(_ref, ["image", "name", "rectangular", "size"]);

  var names = name.split(' ');
  var firstInitial = names[0].slice(0, 1);
  var secondInitial = names.length > 1 ? names[1].slice(0, 1) : firstInitial;
  return /*#__PURE__*/_react.default.createElement(_AvatarImage.ImageContainer, Object.assign({
    rectangular: rectangular,
    size: size
  }, rest), image && (image.src || image.fluid || image.fixed) ? /*#__PURE__*/_react.default.createElement(_AvatarImage.Image, Object.assign({
    mediaType: "image",
    objectFit: "cover",
    aspectRatio: 1
  }, image, {
    alt: name
  })) : /*#__PURE__*/_react.default.createElement(_AvatarImage.Initials, {
    size: size
  }, firstInitial, secondInitial));
};

AvatarImage.propTypes = {
  image: _propTypes.default.shape({
    src: _propTypes.default.string,
    fluid: _propTypes.default.shape({}),
    fixed: _propTypes.default.shape({})
  }).isRequired,
  name: _propTypes.default.string,
  size: _propTypes.default.oneOf(['small', 'medium', 'large']),
  rectangular: _propTypes.default.bool
};
AvatarImage.defaultProps = {
  name: '',
  size: 'medium',
  rectangular: false
};
var _default = AvatarImage;
exports.default = _default;